// Without input for this long, the app is open but no one is working in it (#371).
const IDLE_MS = 3 * 60_000;
export const HEARTBEAT_MS = 60_000;
// Opening or reloading the app is the user acting too.
let lastInput = Date.now();
const mark = () => { lastInput = Date.now(); };

if (typeof window !== 'undefined') {
  for (const ev of ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart', 'scroll'] as const) {
    window.addEventListener(ev, mark, { passive: true, capture: true });
  }
}

export const userIsActive = (): boolean =>
  typeof document !== 'undefined' && document.visibilityState === 'visible' && Date.now() - lastInput < IDLE_MS;

/** Of several open tabs or windows, only the one in front speaks for the user. */
export const shouldBeat = (): boolean => userIsActive() && typeof document !== 'undefined' && document.hasFocus();

let device: 'desktop' | 'tablet' | 'phone' | undefined;
/** By pointer and screen, not User-Agent: iPads identify as Macs. */
export function deviceClass(): 'desktop' | 'tablet' | 'phone' {
  if (device) return device;
  if (typeof window === 'undefined' || !window.matchMedia) return 'desktop';
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const short = Math.min(window.screen?.width ?? 1024, window.screen?.height ?? 768);
  device = !coarse ? 'desktop' : short < 600 ? 'phone' : 'tablet';
  return device;
}
